import { v4 as uuid } from "uuid";

import * as EntityOrganisation from "../entities/organisation";
import { ProfileLineItem } from "./profile";
export type Organisation = EntityOrganisation.Organisation;

export type OrganisationLineItem = {
  id: string;
  organisationName: string;
  tradingName: string;
  abn: string;
  representativeName: string;
  representativeEmail: string;
  phoneNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  postCode: string;
  country: string;
  state: string;
  organisationLogo: string;
  organisationLogoSrc: string;
  planType: string;
  stripeId: string;
  users: ProfileLineItem[];
  created: Date;
};

export const createDefaultOrganisation = (
  email?: string
): OrganisationLineItem => {
  return {
    id: uuid(),
    organisationName: "",
    tradingName: "",
    abn: "",
    representativeName: "",
    representativeEmail: email || "",
    phoneNumber: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    postCode: "",
    country: "AU",
    state: "",
    organisationLogoSrc: "logo.png",
    organisationLogo: "logo.png",
    planType: "Free",
    stripeId: "",
    users: [],
    created: new Date(),
  };
};

export const getOrganisationName = (org: OrganisationLineItem): string => {
  if (org.organisationName.length > 0) {
    return org.organisationName;
  }
  return org.representativeEmail;
};
